import { CacheContext } from 'app/components/ReactContexts/cacheContext';
import { EquipmentListContext } from 'app/components/ReactContexts/equipmentListContext';
import { GlobalErrorContext } from 'app/components/ReactContexts/globalErrorContext';
import { WordmarkLoader } from 'app/components/loaders';
import CancelledRequestError from 'errors/CancelledRequestError';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { api } from 'services/api';
import { EquipmentContentEmpty } from '../EquipmentContentEmpty';
import { useFetchAndSetEquipmentData } from './hooks';
import useFlag from 'app/hooks/useFlag';
import { FeatureName } from 'types/entities/MobileSettings';

export function EquipmentNotLoaded() {
  const { equipmentListData: data } = React.useContext(EquipmentListContext);
  const { getApiModels } = React.useContext(CacheContext);
  const { addErrorModal } = React.useContext(GlobalErrorContext);

  const isAccessSharingPageEnabled = useFlag(FeatureName.ACCESS_SHARING);

  const { isFetching: isInvitationsFetching } = api.useGetInvitationsQuery(
    undefined,
    {
      skip: !isAccessSharingPageEnabled,
    },
  );

  const { t } = useTranslation();

  const fetchAndSetEquipment = useFetchAndSetEquipmentData();

  React.useEffect(() => {
    if (data.equipmentList) {
      return;
    }

    const abortController = new AbortController();

    (async () => {
      await getApiModels();
      try {
        await fetchAndSetEquipment({
          options: { signal: abortController.signal },
        });
      } catch (ex: any) {
        if (
          ex instanceof CancelledRequestError ||
          ex.name === 'AbortError' ||
          ex.message === 'canceled'
        ) {
          return;
        }

        addErrorModal();
      }
    })();
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <>
      {data.isInitialized &&
      data.equipmentList?.length === 0 &&
      !isInvitationsFetching ? (
        <EquipmentContentEmpty />
      ) : (
        <WordmarkLoader title={t('loading_equipment...')} />
      )}
    </>
  );
}
